import DismissableInlineMessage from './dismissable-inline-message';
import StyledTitle from './styled-title';

export { StyledTitle };

export default DismissableInlineMessage;
export * from './inline-message';
